import Shuffle from "shufflejs";

const init = (container, element, filters, options) => {
    const shuffleInstance = new Shuffle(element, Object.assign({
        group: container.querySelector(".js-shuffle-filter")?.dataset?.filter,
        itemSelector: ".js-shuffle-item"
    }, options));

    filters.forEach(item => {
        item.addEventListener('click', () => {
            shuffleInstance.filter(item?.dataset?.filter);
            filters.forEach(item => {
                item.classList.remove('btn--filter--active');
            });
            item.classList.add('btn--filter--active');
        });
    });
    container.removeAttribute('x-masonry-cloak');
    return shuffleInstance;
};

export const initShuffle = (wrapperSelector, options = {}) => {

    const container = document.querySelector(wrapperSelector);


    if (container) {

        const filters = container.querySelectorAll(".js-shuffle-filter");

        if (filters) {
            const element = container.querySelector('.js-shuffle');

            if (element) {

                let nbLoaded = 0;

                const images = container.querySelectorAll('.lazyload');

                container.addEventListener('lazybeforeunveil', function (e) {
                    nbLoaded++;
                    if (nbLoaded === images.length) {
                        init(container, element, filters, options);
                    }
                });

            }
        }

        Shuffle.ShuffleItem.Scale = {
            VISIBLE: 1,
            HIDDEN: 1,
        };
    }
}
